<template>
  <label :for="'radioCard-' + option.id">
    <Card :class=" {
            'shadow' : isSelected,
            'bg-transparent border' : !isSelected,
          }"
          :header="header"
    >
      <div class="form-check form-check-xl d-flex align-items-center">
        <input class="form-check-input mt-0" type="radio"
               name="radioCard"
               :id="'radioCard-' + option.id"
               :value="option.id"
               :checked="isSelected"
               @change="inputEventHandler(option)">
        <div>
          <div class="form-check-label line-height-1">
            <slot/>
          </div>
        </div>
      </div>

      <TransitionVerticalCollapse>
        <div v-if="isSelected">
          <div class="mt-3 pt-3 border-top">
            <slot name="details" />
          </div>
        </div>
      </TransitionVerticalCollapse>

    </Card>
  </label>
</template>

<script>

import Card from '@shared/components/Card'
import TransitionVerticalCollapse from '@shared/components/TransitionVerticalCollapse'

export default {
  components: { TransitionVerticalCollapse, Card },
  props: {
    value: Object,
    option: Object,
    header: String
  },
  computed: {
    isSelected() {
      return this.option.id === this.value?.id
    }
  },
  methods: {
    inputEventHandler(value) {
      this.$emit('input', value)
    }
  }
}
</script>
